"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmountTypes = void 0;
var AmountTypes;
(function (AmountTypes) {
    AmountTypes["ABSOLUTE"] = "ABSOLUTE";
    AmountTypes["RELATIVE"] = "RELATIVE";
})(AmountTypes || (exports.AmountTypes = AmountTypes = {}));
//# sourceMappingURL=amount-types.enum.js.map